import React, { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';

// Import styles and theme
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';

// Import the new single page components
import Header from './components/sections/Header';
import HeroSection from './components/sections/HeroSection';
import CrisisResponseSection from './components/sections/CrisisResponseSection';
import TrustSignalsSection from './components/sections/TrustSignalsSection';
import AboutSection from './components/sections/AboutSection';
import ServicesSection from './components/sections/ServicesSection';
import CaseStudySection from './components/sections/CaseStudySection';
import MethodologySection from './components/sections/MethodologySection';
import QualificationSection from './components/sections/QualificationSection';
import ContactSection from './components/sections/ContactSection';
import Footer from './components/sections/Footer';
import PrivacyPolicy from './components/sections/PrivacyPolicy';
import TermsOfService from './components/sections/TermsOfService';

function App() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsOfService, setShowTermsOfService] = useState(false);

  const openPrivacyPolicy = () => setShowPrivacyPolicy(true);
  const closePrivacyPolicy = () => setShowPrivacyPolicy(false);
  const openTermsOfService = () => setShowTermsOfService(true);
  const closeTermsOfService = () => setShowTermsOfService(false);

  useEffect(() => {
    // Set document title and meta description for SEO
    document.title = 'Antony Haines - Fractional CTO for Manufacturing | IT/OT Convergence Expert';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    const description = 'Fractional CTO services for US mid-market manufacturers ($100M-$2B revenue). Expert in IT/OT convergence, Fortune 500 track record. From crisis to competitive advantage.';
    
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    // Add smooth scrolling CSS if not already present
    if (!document.querySelector('style[data-smooth-scroll]')) {
      const smoothScrollStyle = document.createElement('style');
      smoothScrollStyle.setAttribute('data-smooth-scroll', 'true');
      smoothScrollStyle.textContent = `
        html {
          scroll-behavior: smooth;
        }
        
        @media (prefers-reduced-motion: reduce) {
          html {
            scroll-behavior: auto;
          }
        }
      `;
      document.head.appendChild(smoothScrollStyle);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <div className="App">
        <Header />
        <main>
          <HeroSection />
          <CrisisResponseSection />
          <TrustSignalsSection />
          <AboutSection />
          <ServicesSection />
          <CaseStudySection />
          <MethodologySection />
          <QualificationSection />
          <ContactSection />
        </main>
        <Footer 
          onOpenPrivacyPolicy={openPrivacyPolicy}
          onOpenTermsOfService={openTermsOfService}
        />
        
        <PrivacyPolicy 
          isOpen={showPrivacyPolicy} 
          onClose={closePrivacyPolicy} 
        />
        
        <TermsOfService 
          isOpen={showTermsOfService} 
          onClose={closeTermsOfService} 
        />
      </div>
    </ThemeProvider>
  );
}

export default App;